// eslint-disable-next-line import/no-extraneous-dependencies
const mutations = {
  SET_INDENT_TRACKING(state, data) {
    state.trackingList = data;
  },
  SET_EXCESS_MATERIAL_LOADING(state, status) {
    state.isExcessMaterialLoading = status;
  },
  SET_EXCESS_MATERIALS(state, data) {
    state.excessMaterials = data;
  },
  // POD Bulk Upload mutations
  SET_ACTIVE_POD_BULK_UPLOAD(state, data) {
    state.activePodBulkUpload = data;
  },
  CLEAR_ACTIVE_POD_BULK_UPLOAD(state) {
    state.activePodBulkUpload = null;
  },
  SET_POD_BULK_UPLOAD_ID(state, id) {
    state.podBulkUploadId = id;
  },
  SET_POD_BULK_UPLOAD_DATA(state, data) {
    state.podBulkUploadData = data;
  },
  SET_POD_BULK_STATUS(state, status) {
    state.podBulkStatus = status;
  },
  SET_POD_BULK_STATUS_DATA(state, data) {
    state.podBulkStatusData = data;
  },
  CLEAR_POD_BULK_UPLOAD_STATE(state) {
    state.activePodBulkUpload = null;
    state.podBulkUploadId = null;
    state.podBulkUploadData = null;
    state.podBulkStatus = null;
    state.podBulkStatusData = null;
  },
};

export default mutations;
